import styled from 'styled-components';
import { colors, fonts, metrics } from '@/theme';

const { mobile } = metrics;

export const Container = styled.div`
  ${fonts.getTitle(false)};
  margin-bottom: 72px;
  border-top: solid 1px ${colors.black};
  padding-top: 44px;
  
  @media (max-width: ${mobile}px) {
    margin-bottom: 32px;
    padding-top: 10px;
    margin-top: 10px;
  }
`;
